"use client";

import { Link2 } from "lucide-react";
import { TextLinkCTA } from "~/components/siteglue/siteglue-cta";
import {
  FadeIn,
  HomeEyebrow,
  HomeHeading,
  HomeLead,
  HomeSection,
} from "~/components/siteglue/home/section-shell";
import { MARKETING_PRODUCT_INTEGRATIONS } from "~/lib/inbound-gpt/paths";

const INTEGRATIONS = [
  "Google Calendar",
  "Calendly",
  "Zoom",
  "Juvonno",
  "NexHealth",
  "Custom MCP",
] as const;

export function SiteGlueHomeIntegrations() {
  return (
    <HomeSection id="integrations" tone="white">
      <FadeIn className="mx-auto max-w-2xl text-center">
        <HomeEyebrow>Integrations</HomeEyebrow>
        <HomeHeading className="mx-auto">Connect the tools your team already trusts.</HomeHeading>
        <HomeLead className="mx-auto">
          Supported scheduling and EMR connections when available—plus interim workflows and custom
          MCP requests when you need something deeper.
        </HomeLead>
      </FadeIn>

      <ul className="mt-12 flex flex-wrap items-center justify-center gap-3">
        {INTEGRATIONS.map((name, i) => (
          <FadeIn key={name} delay={0.04 * i}>
            <li className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-4 py-2.5 text-sm font-medium text-slate-800">
              <Link2 className="h-3.5 w-3.5 text-[#4f81bd]" aria-hidden />
              {name}
            </li>
          </FadeIn>
        ))}
      </ul>

      <p className="mx-auto mt-6 max-w-2xl text-center text-xs text-slate-500">
        Capabilities vary by plan and integration.
      </p>
      <div className="mt-6 text-center">
        <TextLinkCTA
          action="discoverPlatform"
          href={MARKETING_PRODUCT_INTEGRATIONS}
          location="feature_section"
          label="Explore integrations"
        />
      </div>
    </HomeSection>
  );
}
